import { useEffect } from 'react';
import { useRef } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { FloodExplorer } from './components/FloodExplorer';
import { Footer } from './components/Footer';
import ScrollToTop from './components/general/ScrollToTop';
import { Header } from './components/Header';
import { Main } from './components/Main';
import { Modals } from './components/modals/index';

import { persistor, store } from './store';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Function to load Google Analytics script dynamically
const loadGAScript = trackingId => {
  if (
    !document.querySelector(
      `script[src="https://www.googletagmanager.com/gtag/js?id=${trackingId}"]`,
    )
  ) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
    };
  }
};

// Custom hook to handle Google Analytics pageview tracking
const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    const googleAnalyticsToken = process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN || null;

    if (googleAnalyticsToken) {
      // Load Google Analytics script if not already loaded
      loadGAScript(googleAnalyticsToken);

      if (window.gtag) {
        window.gtag('config', googleAnalyticsToken, {
          page_path: location.pathname,
        });
      }
    }
  }, [location]);
};

const Router = () => {
  usePageViews(); // Call the custom hook to track page views

  const mapRef = useRef(null);

  return (
    <>
      <Header />
      <div className="bg-blue" style={{ height: 'calc(100% - 60px' }}>
        <Routes>
          <Route path="/" element={<Main />}>
            <Route index element={<FloodExplorer mapRef={mapRef} />} />
          </Route>
        </Routes>
        <Modals mapRef={mapRef} />
        <ToastContainer />
      </div>
      <Footer />
      <ScrollToTop />
    </>
  );
};

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

export default App;
